import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import DrawCloseIcon from '../Icon/DrawCloseIcon'

export interface DrawCenter {
  open: boolean
  children: JSX.Element[] | JSX.Element
  title: string
  onClose: () => void
  containerClassName?: string
  titleContainerClassName?: string
}

function DrawCenter({
  open,
  children,
  title,
  onClose,
  containerClassName = '',
  titleContainerClassName = '',
}: DrawCenter) {
  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as='div' className='relative z-[9999]' onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter='ease-in-out duration-500'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in-out duration-500'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bg-[#000000c5]' />
        </Transition.Child>
        <Transition.Child
          as={Fragment}
          enter='transform transition ease-in-out duration-500'
          enterFrom='translate-y-full'
          enterTo='translate-y-0'
          leave='transform transition ease-in-out duration-500'
          leaveFrom='translate-y-0'
          leaveTo='translate-y-full'
        >
          <Dialog.Panel
            className={`pointer-events-auto fixed left-1/2 top-1/2 z-50 flex h-full max-h-[800px] w-[780px] !-translate-x-1/2 !-translate-y-1/2 overflow-hidden rounded-sm bg-white pb-6 shadow-md ${containerClassName}`}
          >
            <div className='w-full'>
              <div className={`h-[72px] px-5 pt-5 ${titleContainerClassName}`}>
                <Dialog.Title as='h2' className='text-xl font-bold'>
                  {title}
                </Dialog.Title>

                <button
                  onClick={onClose}
                  className='absolute right-3 top-5 z-10 cursor-pointer outline-none'
                >
                  <DrawCloseIcon />
                </button>
              </div>
              <div className='hiddenScrollBar h-full overflow-y-auto px-5'>
                {children}
              </div>
            </div>
          </Dialog.Panel>
        </Transition.Child>
      </Dialog>
    </Transition>
  )
}

export default DrawCenter
